import APIService from '@/services/APIService.js'

export default {
  get () {
    return APIService.apiCall().get('/bdgdVersoes/get')
  },
  switchAtiva (id) {
    return APIService.apiCall().post(`/bdgdVersoes/switch-ativa/${id}`)
  },
}
